import { render, staticRenderFns } from "./receive-stock-movement-confirmation.vue?vue&type=template&id=688a238a&"
import script from "./receive-stock-movement-confirmation.vue?vue&type=script&lang=js&"
export * from "./receive-stock-movement-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports